import { Button, Drawer, Form, Input, InputNumber, Select, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const MerchantEditAddService = ({
  open,
  close,
  setLoading,
  getAddtionalServiceList,
  selectedData,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [form] = Form.useForm();
  const [isSRPOff, setIsSRPOff] = useState(selectedData.is_srp_off);
  const [selectedType, setSelectedType] = useState(selectedData.service_type);

  const handleEditAddService = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/edit-additional-service", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Edited service successfully.");
          setTimeout(() => {
            close();
            form.setFieldsValue({
              product: "",
              description: "",
              category: "",
              price: "",
            });
            setLoadings(false);
            setLoading(false);
            getAddtionalServiceList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Edit Additional Service"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <Form
          form={form}
          layout="vertical"
          name="edit-additional-service"
          initialValues={{
            service: selectedData.service,
            service_desc: selectedData.service_desc,
            service_type: selectedData.service_type,
            service_duration: selectedData.service_duration,
            srp: selectedData.srp,
            is_srp_off: parseInt(selectedData.is_srp_off),
            before_srp: selectedData.before_srp,

            service_charge_exempted: parseInt(
              selectedData.service_charge_exempted
            ),
          }}
          onFinish={handleEditAddService}
          autoComplete="off"
        >
          <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
            <Form.Item
              name="service"
              label="Service Name"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set product name" size="large" />
            </Form.Item>

            <Form.Item name="service_desc" label="Service Description">
              <Input placeholder="Set product description" size="large" />
            </Form.Item>

            <Form.Item
              name="service_type"
              label="Service Type"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                size="large"
                showSearch
                onChange={(e) => setSelectedType(e)}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={"consumable"}>Consumable</Select.Option>
                <Select.Option value={"duration"}>Duration</Select.Option>
                <Select.Option value={"one-time"}>One Time</Select.Option>
              </Select>
            </Form.Item>

            {selectedType === "duration" && (
              <Form.Item
                name="service_duration"
                label="Service Duration"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select
                  placeholder="Select"
                  size="large"
                  showSearch
                  onChange={(e) => console.log("EVENT", e)}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Select.Option value={"hour"}>Hour</Select.Option>
                  <Select.Option value={"day"}>Day</Select.Option>
                  <Select.Option value={"month"}>Month</Select.Option>
                </Select>
              </Form.Item>
            )}

            <Form.Item
              name="srp"
              label="SRP"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={1}
                max={999999999999}
                initialvalues={0}
                size="large"
                style={{ width: "100%" }}
                step="0.01"
              />
            </Form.Item>

            <Form.Item
              name="is_srp_off"
              label="Allow SRP off"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                onChange={(e) => setIsSRPOff(e)}
              >
                <Select.Option value={0}>No</Select.Option>
                <Select.Option value={1}>Yes</Select.Option>
              </Select>
            </Form.Item>

            {parseInt(isSRPOff) === 1 && (
              <Form.Item
                name="before_srp"
                label="Before SRP"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <InputNumber
                  min={1}
                  max={999999999999}
                  initialvalues={0}
                  size="large"
                  style={{ width: "100%" }}
                  step="0.01"
                />
              </Form.Item>
            )}

            <Form.Item
              name="service_charge_exempted"
              label="Service Charge Exempted"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                // onChange={(e) => setIsSRPOff(e)}
              >
                <Select.Option value={0}>No</Select.Option>
                <Select.Option value={1}>Yes</Select.Option>
              </Select>
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      )}
    </Drawer>
  );
};

export default MerchantEditAddService;
